import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { createResource, useResource } from '@/lib/i18n'
import LazyLoad from 'react-lazyload'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar } from 'swiper'
SwiperCore.use([Pagination, Scrollbar])

const resource = createResource({
  en: {
    title: 'Ongoing Promos',
  },
  id: {
    title: 'Promo Yang Sedang Berlangsung',
  },
})

const Promotion = () => {
  const { t } = useResource(resource)
  const promotionItem = [
    {
      url: 'https://bit.ly/KPBrightBalance',
      image: '/images/home/promo-banner-bright.png',
      mobileImage: '/images/home/promo-banner-bright-m.png',
    },
    {
      url: 'https://www.kreditpintar.com/education/syarat-dan-ketentuan-radiant-victory',
      image: '/images/home/promo-banner-radiant.png',
      mobileImage: '/images/home/promo-banner-radiant-m.png',
    },
    {
      url: 'https://www.kreditpintar.com/education/syarat-dan-ketentuan-driven-forward',
      image: '/images/home/promo-banner-driven.png',
      mobileImage: '/images/home/promo-banner-driven-m.png',
    },
  ]
  const { width } = useWindowSize()

  return (
    <Wrapper>
      <h2 className="title">{t('title')}</h2>
      <div className="container">
        <Swiper loop pagination={{ clickable: true }} scrollbar={{ draggable: true }} autoplay={{ delay: 3000, disableOnInteraction: false }}>
          {promotionItem.map((item, index) => (
            <SwiperSlide key={index}>
                <Link href={item.url}>
                  <a target="_blank">
                    <LazyLoad>
                      <img className="banner" src={width > 1000 ? item.image : item.mobileImage} alt="promo-banner" />
                    </LazyLoad>
                  </a>
                </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Wrapper>
  )
}
export default Promotion

const Wrapper = styled.div`
  padding: 104px 150px 0px;
  text-align: center;
  max-width: 1440px;
  margin: 0 auto;

  .title {
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    font-size: 36px;
    line-height: 48px;
    margin-bottom: 48px;
  }
  .container {
    margin: 0 auto;
    .banner {
      width: 100%;
      border-radius: 8px;
      border: 1px solid #e6eaf0;
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 1000px) {
    padding: 0;
    margin: 64px 20px 0 20px;
    text-align: center;
    max-width: 1440px;
    .title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 32px;
    }
  }
`
